module.exports = __webpack_public_path__ + "static/img/rank_58.207c5a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_58.png
// module id = gXtX
// module chunks = 1